import React, { useState } from 'react'
import { useAccount } from '../../../../../common/useAccount'
import { MeetingProviderAccountIntegrationConfig } from '../../../../../models/Account'
import { Modal } from '../../../../../components/Modal/Modal'
import { Container, Row, Col } from 'react-bootstrap'
import { BaseSSOIntegrationConnector } from '../../SSOIntegrationConnectors/BaseSSOIntegrationConnector'
import { IntegrationServiceId } from '../../../../../common/integrations'

type RingCentralIntegrationProps = {
  startConnect: boolean
  onConnected: () => void
  postConnectRedirectPath?: string
}

export const RingCentralWarningModal = ({ show, onHide, onConnect }: { show: boolean; onHide: () => void; onConnect: () => void }) => {
  const body = (
    <Container className='p-0 py-3'>
      <Row className='pb-3'>
        <Col className='p-0'>
          <div className='paragraph-medium d-flex align-items-center gap-3 px-3 py-2 rounded zocks-bg-color-gray-100 zocks-border-0.5'>
            <i className='bi bi-info-circle' />
            <p>
              <strong>RingCentral</strong> is already <strong>set as shared phone line</strong> solution to your account. Your{' '}
              <strong>calls will be handled by this integration</strong> when connecting is done.
            </p>
          </div>
        </Col>
      </Row>
    </Container>
  )

  return (
    <Modal
      show={show}
      onHide={onHide}
      header={<h4 className='d-flex justify-content-center align-items-center'>Connect RingCentral</h4>}
      body={body}
      showFooterActions={true}
      footerPrimaryActionTitle='Acknowledge'
      onFooterPrimaryAction={onConnect}
      centered
    />
  )
}

export const RingCentralIntegration: React.FC<RingCentralIntegrationProps> = ({ startConnect, onConnected, postConnectRedirectPath }) => {
  const [shouldStartSSO, setShouldStartSSO] = useState(false)
  const { account } = useAccount({ refetchOnMountOrArgChange: false })

  const phoneIntegration = account?.effectiveConfig?.integrations?.find((i) => i.serviceId === IntegrationServiceId.PHONE) as
    | MeetingProviderAccountIntegrationConfig
    | undefined
  const sharedPhoneLineEnabled = phoneIntegration?.sharedPhoneLineEnabled ?? false

  const shouldShowModal = startConnect && sharedPhoneLineEnabled

  const handleConnect = () => {
    setShouldStartSSO(true)
  }

  const handleCancel = () => {
    onConnected()
  }

  return (
    <>
      <RingCentralWarningModal show={shouldShowModal} onHide={handleCancel} onConnect={handleConnect} />
      <BaseSSOIntegrationConnector
        serviceId={IntegrationServiceId.RINGCENTRAL}
        startConnect={shouldStartSSO || (startConnect && !sharedPhoneLineEnabled)}
        onConnected={onConnected}
        stateStep={null}
        postConnectRedirectPath={postConnectRedirectPath}
      />
    </>
  )
}
